import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-global-message-error',
  templateUrl: './global-message-error.component.html',
  styleUrls: ['./global-message-error.component.css']
})
export class GlobalMessageErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
